import { api } from '@/lib/axios';

export type PrioriteTache = 'BASSE' | 'NORMALE' | 'HAUTE';
export type StatutTache = 'A_FAIRE' | 'EN_COURS' | 'EN_REVISION' | 'TERMINE';

export const STATUTS_TACHE: StatutTache[] = ['A_FAIRE', 'EN_COURS', 'EN_REVISION', 'TERMINE'];
export const STATUT_TACHE_LABEL: Record<StatutTache, string> = {
  A_FAIRE: 'À faire', EN_COURS: 'En cours', EN_REVISION: 'En révision', TERMINE: 'Terminé',
};
export const PRIORITES_TACHE: PrioriteTache[] = ['BASSE', 'NORMALE', 'HAUTE'];
export const PRIORITE_TACHE_LABEL: Record<PrioriteTache, string> = { BASSE: 'Basse', NORMALE: 'Normale', HAUTE: 'Haute' };

export interface Tache {
  id: string;
  titre: string;
  description: string | null;
  chantier_id: string | null;
  chantier_label: string | null;
  responsable_id: string | null;
  responsable_nom: string | null;
  priorite: PrioriteTache;
  statut: StatutTache;
  date_debut: string | null;
  date_echeance: string | null;
}
export interface TacheInput {
  titre: string;
  description?: string | null;
  chantier_id?: string | null;
  responsable_id?: string | null;
  priorite?: PrioriteTache;
  statut?: StatutTache;
  date_debut?: string | null;
  date_echeance?: string | null;
}
export interface TacheFiltres {
  chantier_id?: string | null;
  responsable_id?: string | null;
  priorite?: PrioriteTache | null;
  statut?: StatutTache | null;
}

export async function listTaches(f?: TacheFiltres): Promise<Tache[]> {
  const params: Record<string, string> = {};
  if (f?.chantier_id) params.chantier_id = f.chantier_id;
  if (f?.responsable_id) params.responsable_id = f.responsable_id;
  if (f?.priorite) params.priorite = f.priorite;
  if (f?.statut) params.statut = f.statut;
  const { data } = await api.get<Tache[]>('/taches', { params });
  return data;
}
export async function createTache(payload: TacheInput): Promise<Tache> {
  const { data } = await api.post<Tache>('/taches', payload);
  return data;
}
export async function updateTache(id: string, payload: Partial<TacheInput>): Promise<Tache> {
  const { data } = await api.put<Tache>(`/taches/${id}`, payload);
  return data;
}
export async function changerStatutTache(id: string, statut: StatutTache): Promise<Tache> {
  const { data } = await api.post<Tache>(`/taches/${id}/statut`, { statut });
  return data;
}
export async function deleteTache(id: string): Promise<void> {
  await api.delete(`/taches/${id}`);
}
